export default "__VITE_ASSET__b48b03b0__"